import { companyInfo, sucursales, mision, vision } from '@/mocks/multifierros';

const sucursalImages: Record<string, string> = {
  'suc-rancagua': 'https://public.readdy.ai/ai/img_res/edited_404f9384ca40aea98fdce42f962fb8ec_58f80e58.jpg',
};

export default function AboutHistory() {
  return (
    <>
      {/* Separator */}
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <hr className="border-background-300/40" />
      </div>

      <section id="quienes-somos" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-[960px] mx-auto px-4 md:px-8 text-center">
          <h2 className="font-heading text-4xl md:text-5xl text-foreground-50 tracking-wide">
            NUESTRA HISTORIA
          </h2>
          <h3 className="font-heading text-lg md:text-xl text-foreground-300 tracking-wider mt-2 mb-6">
            SERVICIOS INDUSTRIALES CON CALIDAD NACIONAL
          </h3>
          <p className="text-foreground-300 text-sm md:text-base leading-relaxed text-justify">
            {companyInfo.longDescription} Fabricamos nuestros productos
            bajo las más exigentes normas de la industria minera chilena, utilizando acero ASTM A36, A572 GR50, ANTIABRASIVOS 400-450-500 BHN, A420-630, todo bajo la norma chilena NCH203. Nuestro equipo técnico acompaña cada proyecto desde la
            cotización hasta la entrega final en terreno.
          </p>

          {/* Sucursal única */}
          <div className="mt-12 md:mt-16">
            <h2 className="font-heading text-4xl md:text-5xl text-foreground-50 tracking-wide mb-8">
              CASA MATRIZ
            </h2>
            <div className="max-w-xl mx-auto">
              {sucursales.map((suc) => (
                <div key={suc.imageSeq} className="text-center">
                  <div className="h-52 md:h-64 rounded-sm overflow-hidden mb-4 bg-background-100">
                    <img
                      src={sucursalImages[suc.imageSeq]}
                      alt={suc.name}
                      className="w-full h-full object-cover object-center"
                    />
                  </div>
                  <h4 className="font-heading text-xl text-foreground-200 tracking-wider">
                    {suc.name}
                  </h4>
                  <p className="text-foreground-300 text-sm mt-2 leading-relaxed">
                    {suc.address}<br />{suc.city}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}